import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const exportAndDownloadExcel = (allContacts) => {
  // Create a new worksheet
  const worksheet = XLSX.utils.json_to_sheet(allContacts);

  // Create a new workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Contacts');

  // Convert workbook to binary Excel file
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

  // Create a Blob and trigger download
  const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(data, 'contacts.xlsx');
};
